// extracted by mini-css-extract-plugin
export default {"outerDiv":"UserBlogPosts_outerDiv__6Njzd","innerDiv":"UserBlogPosts_innerDiv__AKqeQ"};